import { Badge } from '@pms-digital/design-system';

export type SettingScope = 'browser' | 'global';

interface ScopeBadgeProps {
  scope: SettingScope;
}

/**
 * Where a setting applies, on its own row: this browser (neutral) or every user
 * of the deployment (info). The "Génération & système" tab mixes both scopes.
 */
export function ScopeBadge({ scope }: ScopeBadgeProps) {
  return scope === 'browser' ? (
    <Badge tone="neutral" icon="desktop_windows" maxWidth="none">
      Ce navigateur
    </Badge>
  ) : (
    <Badge tone="info" icon="language" maxWidth="none">
      Tous les utilisateurs
    </Badge>
  );
}
